import { render, staticRenderFns } from "./_noSistema.vue?vue&type=template&id=083dc396&scoped=true&"
import script from "./_noSistema.vue?vue&type=script&lang=js&"
export * from "./_noSistema.vue?vue&type=script&lang=js&"
import style0 from "./_noSistema.vue?vue&type=style&index=0&id=083dc396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dc396",
  null
  
)

export default component.exports